var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.0294,
    y: 0.10614,
    width: 48,
    height: 48,
    rx: 10,
    transform: "rotate(15 15.0294 0.10614)",
    fill: "#36BFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_43158_26930)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 13.5,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 46.5L23.8999 46.3499C23.2053 45.308 22.858 44.787 22.3991 44.4098C21.9929 44.0759 21.5248 43.8254 21.0216 43.6726C20.4533 43.5 19.8271 43.5 18.5748 43.5H17.2C16.0799 43.5 15.5198 43.5 15.092 43.282C14.7157 43.0903 14.4097 42.7843 14.218 42.408C14 41.9802 14 41.4201 14 40.3V31.7C14 30.5799 14 30.0198 14.218 29.592C14.4097 29.2157 14.7157 28.9097 15.092 28.718C15.5198 28.5 16.0799 28.5 17.2 28.5H17.6C19.8402 28.5 20.9603 28.5 21.816 28.936C22.5686 29.3195 23.1805 29.9314 23.564 30.684C24 31.5397 24 32.6598 24 34.9M24 46.5V34.9M24 46.5L24.1001 46.3499C24.7947 45.308 25.142 44.787 25.6009 44.4098C26.0071 44.0759 26.4752 43.8254 26.9784 43.6726C27.5467 43.5 28.1729 43.5 29.4252 43.5H30.8C31.9201 43.5 32.4802 43.5 32.908 43.282C33.2843 43.0903 33.5903 42.7843 33.782 42.408C34 41.9802 34 41.4201 34 40.3V31.7C34 30.5799 34 30.0198 33.782 29.592C33.5903 29.2157 33.2843 28.9097 32.908 28.718C32.4802 28.5 31.9201 28.5 30.8 28.5H30.4C28.1598 28.5 27.0397 28.5 26.184 28.936C25.4314 29.3195 24.8195 29.9314 24.436 30.684C24 31.5397 24 32.6598 24 34.9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_43158_26930",
    x: -16,
    y: -2.5,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_43158_26930"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_43158_26930",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeed);
export default __webpack_public_path__ + "static/media/feed.03a325ac9de951750c229b510cb029e8.svg";
export { ForwardRef as ReactComponent };